import type { FC, RefObject } from 'react';

import type { MetadataField } from '@/model/Metadata.model';

import Spreadsheet from '@/components/UI/SpreadSheet/Spreadsheet';
import type {
  CompatibleCellChange,
  CompatibleChangeSource,
  SpreadsheetSettings,
} from '@/components/UI/SpreadSheet/Spreadsheet';
import type { HotTableRef } from '@/components/UI/SpreadSheet/HotTable';
import type { SpreadSheetAddRow, SpreadSheetRow } from '@/components/UI/SpreadSheet/SpreadSheet.model';
import { defaultMetadataToColumnSettingMapper } from '@/support/hot';

interface AddAnimalsTableProps {
  data: Array<Record<string, unknown>>;
  settings: SpreadsheetSettings;
  innerRef: RefObject<HotTableRef | null>;
  metadata: Array<MetadataField>;
  setMetadata: (metadata: Array<MetadataField>) => void;
  setInvalid: (invalid: boolean) => void;
  addRow?: SpreadSheetAddRow;
  afterAddRow?: () => void;
  defaultNewRowParams?: Array<SpreadSheetRow>;
  maxRows?: number;
  minSpareRows?: number;
  enableRowHeaderControls?: boolean;
  onRowHeaderAddRow?: (row: number) => void;
  afterChange?: (changes: Array<CompatibleCellChange> | null, source: CompatibleChangeSource) => void;
  afterCreateRow?: (index: number, amount: number, source?: CompatibleChangeSource) => void;
  afterRemoveRow?: (source: CompatibleChangeSource | undefined) => void;
}

const AddAnimalsTable: FC<AddAnimalsTableProps> = ({
  data,
  settings,
  innerRef,
  metadata,
  setMetadata,
  setInvalid,
  addRow,
  afterAddRow,
  defaultNewRowParams,
  maxRows,
  minSpareRows,
  enableRowHeaderControls,
  onRowHeaderAddRow,
  afterChange,
  afterCreateRow,
  afterRemoveRow,
}) => {
  return (
    <Spreadsheet
      className="pl4 pr4"
      testPrefix="add-animals"
      data={data}
      innerRef={innerRef}
      settings={settings}
      metadata={metadata}
      setMetadata={setMetadata}
      setInvalid={setInvalid}
      metadataToColumnSettingMapper={defaultMetadataToColumnSettingMapper}
      addRow={addRow}
      afterAddRow={afterAddRow}
      defaultNewRowParams={defaultNewRowParams}
      maxRows={maxRows}
      minSpareRows={minSpareRows}
      enableRowHeaderControls={enableRowHeaderControls}
      onRowHeaderAddRow={onRowHeaderAddRow}
      afterChange={afterChange}
      afterCreateRow={afterCreateRow}
      afterRemoveRow={afterRemoveRow}
    />
  );
};

export default AddAnimalsTable;
